export default "/dist/files/facebook.19c6eeef94ff65787edd9d975be5075d.svg";